export const COOKIE_ACCEPTANCE = 'CookieAcceptance';